// @flow
import i18n from "../../../../i18n";

export const yesNo = [
  { value: true, text: i18n.t("common:yes") },
  { value: false, text: i18n.t("common:no") },
];
